import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../translations/en.json';
import vi from '../translations/vi.json';
// Import file feature mới
import featureTranslations from '../locales/feature-151025-i18n.json';
import activityFeedTranslations from '../locales/activity-feed-i18n.json';

// Hàm để gộp các object translation (merge deep)
const mergeTranslations = (target: any, source: any) => {
  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      if (typeof source[key] === 'object' && source[key] !== null && !Array.isArray(source[key])) {
        // If target[key] is a string and source[key] is an object, we need to handle the conflict
        if (typeof target[key] === 'string') {
          // Skip this key to avoid the error, or convert target[key] to an object if needed
          target[key] = source[key];
        } else {
          if (!target[key]) {
            target[key] = {};
          }
          mergeTranslations(target[key], source[key]);
        }
      } else {
        target[key] = source[key];
      }
    }
  }
  return target;
};

// Gộp file feature vào file chính
const mergedVi = mergeTranslations(mergeTranslations({...vi}, featureTranslations.vi), activityFeedTranslations.vi);
const mergedEn = mergeTranslations(mergeTranslations({...en}, featureTranslations.en), activityFeedTranslations.en);

const saved = typeof window !== 'undefined' ? (localStorage.getItem('lng') || undefined) : undefined;

i18n.use(initReactI18next).init({
  // Sử dụng bản dịch đã gộp
  resources: { 
    en: { translation: mergedEn }, 
    vi: { translation: mergedVi } 
  },
  lng: saved || 'vi',
  fallbackLng: 'en',
  interpolation: { escapeValue: false }
});

// ... phần còn lại của file giữ nguyên
if (typeof document !== 'undefined') {
  const syncDocumentLanguage = (lng: string) => {
    document.documentElement.lang = lng;
    document.documentElement.setAttribute('translate', 'no');
    document.documentElement.classList.add('notranslate');
    if (document.body) {
      document.body.setAttribute('translate', 'no');
      document.body.classList.add('notranslate');
    }
    const portalRoot = document.getElementById('portal-root');
    if (portalRoot) {
      portalRoot.setAttribute('translate', 'no');
      portalRoot.classList.add('notranslate');
    }
  };

  syncDocumentLanguage(i18n.language);
  i18n.on('languageChanged', syncDocumentLanguage);
}

export default i18n;